<template>
  <div class="live_wrap">
    <div class="live_item">
      <div class="img_container">
        <img :src="videoImg" />
      </div>
      <div class="content_container">
        <div class="title">
          <div class="text">{{dataItem.title}}</div>
          <div class="is_new" v-if="dataItem.is_new">
            <div class='is_new_item'></div>
          </div>
        </div>
        <div class="experts_info">
          <div class="info_wrap">
            <div class="name">{{dataItem.author}}</div>
            <div class="office">{{dataItem.institute}}</div>
          </div>
        </div>
        <div class="live_message">
          <div class="live_time">
            <span class="label">直播时间:</span>
            <span>{{dataItem.live_time}}</span>
          </div>
          <div class="sorce">
            <span class="label">来源:</span>
            <span>{{dataItem.source}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tumor from '@/assets/images/tumor.png'
import Other from '@/assets/images/other.png'
import Mx from '@/assets/images/manxing.png'
export default {
  props:['dataItem'],
  data() {
    return {
      videoImg:''
    }
  },
  created() {
    this.videoImg = this.switchHandle(this.dataItem.field_level1)
  },
  methods:{
    switchHandle(data) {
      switch(data) {
        case '肿瘤':
          return Tumor
        case '其他':
          return Other
        case '慢性疾病':
          return Mx
      }
    }
  }
}
</script>

<style lang="less" scoped>
.live_wrap{
  width:100%;
  padding: 0.2rem 0.16rem 0 0.15rem;
  .live_item{
    display: flex;
    padding-bottom: 0.16rem;
    border-bottom: 1px solid #EFEFEF;
    .img_container{
      min-width: 0.88rem;
      width: 0.88rem;
      height: 0.88rem;
      & img{
        width: 100%;
        height: 100%;
      }
    }
    .content_container{
      flex: 1;
      padding-left: 0.16rem;
      .title {
        height: 0.44rem;
        overflow: hidden;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:22px;
        display: flex;
        .text{
          flex: 1;
        }
        .is_new{
          margin-left: 0.05rem;
          .is_new_item{
            width: 26px;
            height: 12px;
            margin-top: 3px;
            background:url(../assets/images/is_new.png) no-repeat;
            background-size: cover;
          }
        }
      }
      .experts_info{
        display: flex;
        margin-top: 0.13rem;
        .info_wrap{
          display: flex;
          .name{
            min-width: 0.36rem;
            margin-right: 0.16rem;
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:17px;
          }
          .office{
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:17px;
          }
        }
      }
    }
  }
  .live_message{
    margin-top: 0.12rem;
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:#666666;
    line-height:17px;
    .sorce{
      margin-top: 0.04rem;
    }
    .label{
      margin-right: 0.08rem;
      color: #999999;
    }
  }
}
</style>